module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_3.3dd1e7fb.png";